import Crud from './crud';
import { request_list, update_detail } from '@/commons/hpod';
import Vue from 'vue';
import { refreshResource, sendSuccessNotice } from '@/commons/utils';
var crud = new Crud('products', 'sản phẩm');

const state = {
    ...crud.state,
    exp: {},
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getExpList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('products/exp', data => {
            commit('setExpList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    copyDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        update_detail('products/copy', data => {
            refreshResource();
            commit("setLoading", { loading: false });
            sendSuccessNotice("Đã sao chép sản phẩm.");
        }, Vue.http, {}, id, this.state.authentication.token);
    }
};
const mutations = {
    ...crud.mutations,
    setExpList(state, data) {
        state.exp = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};